<template>
  <el-dialog v-model="formVisible" :title="i18n.$t('Button').others" :width="dialogWidth" :before-close="dialogClose"
    :close-on-click-modal="false" align-center>
    <div>
      <ul class="d-flex">
        <li class="li-container col-6" v-if="noisePointPermission">
          <p class="label-font mb-1">{{ i18n.$t('hide_point') }}</p>
          <el-switch v-model="editNoisePoint" />
        </li>
        <li class="li-container col-6" v-if="dataTypePermission">
          <p class="label-font mb-1">{{ i18n.$t('hide_raw_data') }}</p>
          <el-switch v-model="editDataType" />
        </li>
      </ul>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogClose">{{ i18n.$t('Button')['close'] }}</el-button>
        <el-button v-if="noisePointPermission || dataTypePermission" type="primary" class="btn-confirm"
          @click="emitEditSwitch">{{
    i18n.$t('Button').confirm }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { useI18n } from '@/js/i18n';

export default {
  name: 'othersDialog',
  emits: ['visibleEmit', 'emitEditSwitch', 'emitLogout'],
  setup() {
    const i18n = useI18n();
    return { i18n };
  },
  props: {
    noisePointPermission: {
      type: Boolean,
      default: false,
    },
    dataTypePermission: {
      type: Boolean,
      default: false,
    },
    noisePoint: {
      type: Boolean,
      default: false,
    },
    dataType: {
      type: Boolean,
      default: false,
    },
    othersDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formVisible: this.othersDialogVisible,
      editNoisePoint: this.noisePoint,
      editDataType: this.dataType,
      dialogWidth: '20%',
    };
  },
  methods: {
    emitEditSwitch() {
      const editSwitch = {
        editNoisePoint: this.editNoisePoint,
        editDataType: this.editDataType,
      };
      this.$emit('emitEditSwitch', editSwitch);
      this.$message.success(this.i18n.$t('Msg').update_success);
    },
    emitLogout() {
      this.$emit('emitLogout');
    },
    dialogVisibleSwitch(val) {
      this.$emit('visibleEmit', val);
    },
    dialogClose() {
      this.dialogVisibleSwitch(false);
    },
    setDialogWidth() {
      const windowSize = document.body.clientWidth;
      // console.log(windowSize);
      const defaultWidth = 480; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dialogWidth = '100%';
      } else {
        this.dialogWidth = '480px';
      }
      // console.log(this.dialogWidth);
    },
  },
  watch: {
    othersDialogVisible: {
      handler(val, old) {
        if (val !== old) {
          this.setDialogWidth();
          this.formVisible = val;
          if (val) {
            this.editNoisePoint = this.noisePoint;
            this.editDataType = this.dataType;
          }
        }
      },
    },
  },
};
</script>
<style scoped>
.li-container {
  padding: 0 10px;
}

.label-font {
  font-size: 1rem;
}

.group-tag {
  padding: 4px 10px;
}
</style>
